var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lazy-image-wrapper",class:_vm.wrapperClass},[_c('img',{ref:"lazyImg",class:[
      'lazy-image',
      {
        'lazy-loading': _vm.isLoading,
        'lazy-loaded': _vm.isLoaded,
        'lazy-error': _vm.hasError
      }
    ],attrs:{"src":_vm.placeholderSrc,"alt":_vm.alt,"data-lazy-src":_vm.optimizedSrc,"data-lazy-type":'image'},on:{"load":_vm.onLoad,"error":_vm.onError}}),(_vm.showPlaceholder && (_vm.isLoading || (!_vm.isLoaded && !_vm.hasError)))?_c('div',{staticClass:"lazy-placeholder"},[(!_vm.hasError)?_c('div',{staticClass:"lazy-spinner"},[_c('div',{staticClass:"spinner-ring"})]):_c('div',{staticClass:"lazy-error-msg"},[_c('i',{staticClass:"el-icon-picture-outline"}),_c('span',[_vm._v("图片加载失败")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }